export default {};
throw new Error(`Could not resolve "cldr-data" imported by "@js-joda/locale". Is it installed?`)